module.exports = __webpack_public_path__ + "img/中国钓鱼协会@2x.410b6e39.png";